export const apiBaseUrlQaProveedor   = "https://devexportemos-ws.promperu.gob.pe/EventoBFF"; 
export const apiBaseUrlQa            = "https://api-qa.exportemos.pe/EventoBFF";
export const apiBaseUrlPreProduccion = "https://api-qa2.exportemos.pe/EventoBFF";
export const apiBaseUrlProduccion    = "https://api.exportemos.pe/EventoBFF";

const getApiUrl = () => {
    const host = window.location.hostname;
    // console.log(host);
    let apiUrl = apiBaseUrlQaProveedor;

    if(host === 'localhost' || host === 'exportemos.tk' || host === '127.0.0.1' || host === "devexportemos.promperu.gob.pe" ){
        apiUrl = apiBaseUrlQaProveedor;
    }else if(host === 'exportemos.pe'){
        apiUrl = apiBaseUrlProduccion;
    }else if(host === 'qa.exportemos.pe'){
        apiUrl = apiBaseUrlQa;
    }else if(host === 'qa2.exportemos.pe'){
        apiUrl = apiBaseUrlPreProduccion;
    }
    
    return apiUrl;
}

export const apiBaseUrl = getApiUrl();